<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>(+852) 6221 0198
          <span class="glyphicon glyphicon-envelope" style="margin-left: 10px;"></span>ethanwang@faithruit.com
        </div>
        <div class="social-links pull-right">
          <a href="https://wa.me/85262210198" target="_blank" class="social-link whatsapp" title="WhatsApp">
            <i class="fab fa-whatsapp"></i>
          </a>
          <!-- <a href="#" class="social-link wechat" title="WeChat" @click="showWechatQR">
            <i class="fab fa-weixin"></i>
          </a> -->
          <a href="https://x.com/XTDBT" target="_blank" class="social-link twitter" title="Twitter">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="mailto:ethanwang@faithruit.com" class="social-link email" title="Email">
            <i class="fas fa-envelope"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <router-link to="/" @click="navClick(0, 'Home')">
          <img src="@/assets/img/logo2.png" alt="Faithruit Logo">
        </router-link>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <router-link to="/" @click="navClick(0, 'Home')">
          <img class="center-block" src="@/assets/img/logo_black.png" alt="Faithruit Logo">
        </router-link>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "Home",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "Home",
          path: "/",
          children: []
        },
        {
          name: "Services",
          path: "/service",
          children: []
        },
        {
          name: "Products",
          path: "/software",
          children: [

            {
              name: "AI Event Tracking & Analysis System",
              path: "/software/eventTracking"
            },
            {
              name: "User Behavior Analysis System",
              path: "/software/userBehavior"
            },
            {
              name: "Smart Contract Management System",
              path: "/software/contract"
            },
            {
              name: "Medical Order Matching System",
              path: "/software/medicine"
            },
            {
              name: "Intelligent CRM System",
              path: "/software/crm"
            }

          ]
        },
        {
          name: "About",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "Contact",
          path: "/contactus",
          children: []
        }

      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    showWechatQR() {
      // 显示微信二维码弹窗
      alert('WeChat QR Code: Please scan to add us as friend\n微信二维码：请扫描添加好友');
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all ease 0.6s;
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

#header .header-top {
  height: 40px;
  color: #fff;
  font-size: 11px;
  line-height: 40px;
  background: linear-gradient(90deg, #0f172a 0%, #1e293b 100%);
  letter-spacing: 0.5px;
}

/* 社交网络图标样式 */
.social-links {
  display: flex;
  align-items: center;
  gap: 15px;
  height: 40px;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.social-link:hover {
  color: #38bdf8;
  transform: translateY(-2px);
}

/* 导航栏 */
#header .header-nav {
  height: 80px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 120px;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
}

#header .header-nav .header-nav-logo img {
  width: 100px;
  transition: transform 0.3s ease;
}

#header .header-nav .header-nav-logo img:hover {
  transform: scale(1.05);
}

#header .header-nav-fixed .header-nav-wrapper {
  line-height: 80px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
}

#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
}

#header .header-nav .header-nav-wrapper > li > a {
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: 20px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(90deg, #38bdf8 0%, #818cf8 100%);
}

#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #38bdf8;
}

#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

#header .header-nav .header-nav-wrapper > li.active > a {
  color: #38bdf8;
}

#header .header-nav .header-nav-wrapper > li.active > a .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

#header .header-nav .header-nav-wrapper > li > dl {
  display: block;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 300px;
  top: 100%;
  left: -50px;
  z-index: 1000;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

#header .header-nav .header-nav-wrapper > li:hover dl {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

#header .header-nav .header-nav-wrapper > li > dl > dt {
  padding: 0;
  border: none;
}

#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  display: block;
  padding: 12px 25px;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  background: #f8fafc;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover > a {
  color: #38bdf8;
  padding-left: 30px;
}

/* 移动端 */
@media screen and (max-width: 997px) {
  #header .header-nav-m .header-nav-m-logo {
    height: 70px;
    background: #fff;
  }
  
  #header .header-nav-m .header-nav-m-menu {
    background: #0f172a;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
  }
  
  #header .header-nav-m .header-nav-m-wrapper {
    background: #1e293b;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  #header .header-nav-m .header-nav-m-wrapper > li {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: rgba(255, 255, 255, 0.9);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue